(function () {
  var INDEX_URL = '/pages/search-index';
  var CACHE_KEY = 'local_search_index_v1';
  var CACHE_HOURS = 1;
  var MIN_CHARS = 3;
  // Must match the native predictive search limit (resources[limit] in
  // theme.js and `limit:` in predictive-search.liquid). We top up TO this
  // number, we don't add this many on top.
  var TOTAL_LIMIT = 5;

  var indexData = null;
  var isLoading = false;
  // Set while we're inserting our own results, so the MutationObserver
  // below doesn't treat our own insert as a new native result and loop.
  var isInjectingLocal = false;

  function loadFromCache() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed.savedAt || Date.now() - parsed.savedAt > CACHE_HOURS * 3600000) return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function saveToCache(products) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({
        savedAt: Date.now(),
        products: products
      }));
    } catch (e) {}
  }

  function fetchPage(url, accumulated) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var combined = accumulated.concat(data.products || []);
        return data.next_page ? fetchPage(data.next_page, combined) : combined;
      });
  }
 
  function buildIndex(){
    if (isLoading || indexData) return;
    var cached = loadFromCache();
    if (cached) {
      indexData = cached.products;
      return;
    }
    isLoading = true;
    fetchPage(INDEX_URL, [])
      .then(function (products) {
        indexData = products;
        saveToCache(products);
        isLoading = false;
      })
      .catch(function () { isLoading = false; });
  }

  function norm(str) { return (str || '').toString().toLowerCase(); }

  function matches(product, term) {
    var t = norm(term);
    return (
      norm(product.title).indexOf(t) !== -1 ||
      norm(product.sku).indexOf(t) !== -1 ||
      norm(product.barcode).indexOf(t) !== -1 ||
      norm(product.tags).indexOf(t) !== -1 ||
      norm(product.model_number).indexOf(t) !== -1
    );
  }

  function escapeText(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function getVisibleIds(container) {
    var ids = [];
    container.querySelectorAll('[data-product-id]').forEach(function (el) {
      ids.push(el.getAttribute('data-product-id').toString());
    });
    return ids;
  }

  function renderExtraResults(container, products) {
    var existing = container.querySelector('.js-local-search-extra');
    if (existing) existing.remove();
    var existingLabel = container.querySelector('.js-local-search-extra-label');
    if (existingLabel) existingLabel.remove();
    if (!products.length) return;

    // If native search found nothing, it shows an empty-state message.
    // Remove it now that we actually have results to show.
    var emptyState = container.querySelector('.search-bar__empty-state');
    if (emptyState) emptyState.remove();

    var nativeProducts = container.querySelector('.search-bar__result-products');
    var label = null;
    if (!nativeProducts) {
      label = document.createElement('p');
      label.className = 'search-bar__result-category js-local-search-extra-label';
      label.textContent = 'Products';
    }

    var wrap = document.createElement('div');
    wrap.className = 'search-bar__result-products js-local-search-extra';

    products.forEach(function (p) {
      var a = document.createElement('a');
      a.href = p.url;
      a.className = 'search-bar__result-item';
      a.setAttribute('data-product-id', p.id);

      var imageContainer = document.createElement('div');
      imageContainer.className = 'search-bar__image-container';
      imageContainer.innerHTML =
        '<div class="aspect-ratio aspect-ratio--square">' +
          '<img src="' + escapeText(p.image) + '" alt="' + escapeText(p.title) + '" loading="lazy" width="120" height="120">' +
        '</div>';

      var info = document.createElement('div');
      info.className = 'search-bar__item-info';

      var title = document.createElement('p');
      title.className = 'search-bar__item-title';
      title.textContent = p.title || '';
      info.appendChild(title);

      // Match native behaviour: when pricelock hides the price, native
      // renders no price element at all - so we only add one when we
      // actually have a price, instead of an empty span.
      if (p.price) {
        var price = document.createElement('span');
        price.className = 'search-bar__item-price';
        price.textContent = p.price;
        info.appendChild(price);
      }

      a.appendChild(imageContainer);
      a.appendChild(info);
      wrap.appendChild(a);
    });

    if (nativeProducts) {
      nativeProducts.insertAdjacentElement('afterend', wrap);
    } else {
      if (label) container.appendChild(label);
      container.appendChild(wrap);
    }
  }

  function runLocalSearch(term, resultsInner) {
    if (!indexData || !term || term.length < MIN_CHARS) return;

    var shownIds = getVisibleIds(resultsInner);
    var remaining = TOTAL_LIMIT - shownIds.length;

    isInjectingLocal = true;
    if (remaining <= 0) {
      // Native already filled the quota on its own - make sure we don't
      // leave a stale extra block from a previous, shorter result set.
      renderExtraResults(resultsInner, []);
    } else {
      var extra = indexData
        .filter(function (p) {
          return shownIds.indexOf(p.id.toString()) === -1 && matches(p, term);
        })
        .slice(0, remaining);
      renderExtraResults(resultsInner, extra);
    }
    // Let the MutationObserver's microtask queue flush before clearing the
    // guard, so it ignores the mutation we just caused.
    setTimeout(function () { isInjectingLocal = false; }, 0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    buildIndex();

    var input = document.querySelector('.search-bar__input');
    var resultsInner = document.querySelector('.search-bar__results-inner');
    if (!input || !resultsInner) return;

    // Clear our extra block immediately when the term drops below the
    // threshold - native handles clearing its own results on its own timer,
    // we don't want to wait around showing stale extras.
    input.addEventListener('input', function (e) {
      var term = e.target.value.trim();
      if (term.length < MIN_CHARS) {
        var existing = resultsInner.querySelector('.js-local-search-extra');
        if (existing) existing.remove();
        var existingLabel = resultsInner.querySelector('.js-local-search-extra-label');
        if (existingLabel) existingLabel.remove();
      }
    });

    // Fires only when native predictive search has actually replaced the
    // results HTML - not on a guessed timer, so this can't race a slow
    // network response and get wiped out or double up.
    var observer = new MutationObserver(function () {
      if (isInjectingLocal) return;
      var term = input.value.trim();
      if (term.length < MIN_CHARS) return;
      runLocalSearch(term, resultsInner);
    });
    observer.observe(resultsInner, { childList: true });
  });
})();